import React from 'react';
import './ScheduledReportingModal.scss';
import { useTranslation } from 'react-i18next';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import { DataTable, DateTimeField, Field } from '../../../commons/DataTable';
import QueueJobRequestStatusField from '../../../commons/DataTable/QueueJobRequestStatusField';
import ModalSeeExtraIafs from './ModalSeeExtraIafs';
import { ContFilterYear, ContPaginationPage } from '../../../styled-components';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';

const ExtraIafs = ({ queueJobRequests, query, total, onFilter }) => {
  const [t] = useTranslation('SCHEDULED_REPORTING');
  const { year, status, limit, offset, business } = query;

  return (
    <section>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <section>
            <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_YEAR_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="year"
                          name="year"
                          value={query && query.year}
                          onChange={({ target: { value: year } }) =>
                            onFilter({ year })
                          }
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            </Row>
          </section>

          <section style={{ marginTop: '1rem' }}>
            <DataTable
              data={queueJobRequests}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              emptyText={t('COMMON:NO_DATA')}
              loadingText={t('LOADING')}
            >
              <DateTimeField
                title="Data rendicontazione"
                source="createdAt"
                format="DD/MM/YYYY"
              />
              <QueueJobRequestStatusField
                title="Stato richiesta"
                source="status"
              />
              <Field title="Eventi totali" source="totalJobs" />
              <Field title="Eventi completati" source="completedJobs" />
              <Field title="Eventi falliti" source="failedJobs" />
              <ModalSeeExtraIafs title="Azioni" business={business} />
            </DataTable>

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>
          </section>
        </TabPane>
      </TabContent>
    </section>
  );
};

export default ExtraIafs;
